// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2_xTm","rootSuccess":"CompleteLink_rootSuccess__1c4Zw","rootFailure":"CompleteLink_rootFailure__1B7iF","isDisabled":"CompleteLink_isDisabled__1sG9X"};